var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { FILE_LOCKING_EXTENSIONS } from '@lucidlink/sdk';
import { InlineForm, TagInputField, translate } from '@lucidlink/uicore';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { DEPENDENCY_KEYS, useDependency } from '#context';
const FILE_LOCKING_EXTENSIONS_ID = 'file-locking-extensions';
export const FileLockingExtensions = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const { handleToasts } = useDependency(DEPENDENCY_KEYS.UseFilespaceSettingsToasts)({
        filespaceId,
        workspaceId,
        settingName: FILE_LOCKING_EXTENSIONS,
    });
    const { formData: { fileLockingExtensions: formFileLockingExtensions = [] }, } = useFormRoot();
    const { mutation: { isSuccess, mutate: setGlobalSettings }, } = useDependency(DEPENDENCY_KEYS.UseSetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: FILE_LOCKING_EXTENSIONS,
    }, {
        onSuccess: () => {
            handleToasts();
        },
    });
    const setFileLockingExtensions = useCallback(() => {
        setGlobalSettings([
            {
                fullName: FILE_LOCKING_EXTENSIONS,
                value: formFileLockingExtensions.join(','),
            },
        ]);
    }, [formFileLockingExtensions, setGlobalSettings]);
    const { mutation: { mutate: unsetGlobalSetting }, } = useDependency(DEPENDENCY_KEYS.UseUnsetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: FILE_LOCKING_EXTENSIONS,
    }, {
        onSuccess: () => {
            handleToasts({ isReset: true });
        },
    });
    const unsetFileLockingExtensions = useCallback(() => unsetGlobalSetting([FILE_LOCKING_EXTENSIONS]), [unsetGlobalSetting]);
    const { default: defaultValue, isDefault, value } = data;
    const resetToDefault = isDefault
        ? undefined
        : {
            label: translate('Reset to default'),
            onReset: unsetFileLockingExtensions,
            tooltip: translate(`The default value is: {{defaultValue}}`, {
                defaultValue,
            }),
        };
    const labelDefault = isDefault ? translate('Default') : undefined;
    const labelTooltip = useMemo(() => [
        translate('Windows only. File locking will be applied to the specified file extensions when opened'),
        translate('On macOS, only InDesign file locking is supported.'),
    ], []);
    return (_jsx(InlineForm, { cancelAriaLabel: translate('cancel changing file locking extensions'), "data-testid": FILE_LOCKING_EXTENSIONS_ID, formElement: (labelProps) => (_jsx(TagInputField, { getTagErrorText: ({ code }) => translate(code), ...labelProps, autoFocus: true, "data-testid": FILE_LOCKING_EXTENSIONS_ID, id: FILE_LOCKING_EXTENSIONS_ID, initialValue: value.split(','), name: "fileLockingExtensions" })), inputId: FILE_LOCKING_EXTENSIONS_ID, isSaveAllowed: value !== formFileLockingExtensions?.join(','), isSuccess: isSuccess, label: translate('File locking extensions'), labelDefault: labelDefault, labelTooltip: labelTooltip, onSave: setFileLockingExtensions, resetToDefault: resetToDefault, saveAriaLabel: translate('save file locking extensions'), tooltipPosition: "right", value: value }));
};
_react_refresh_temp_1 = FileLockingExtensions;
$RefreshReg$(_react_refresh_temp_1, "FileLockingExtensions");
_react_refresh_temp_2(FileLockingExtensions, "lJ9iihfi8/eWZoq1EwBzC+A2PJE=", false, () => [useDependency, useFormRoot, useDependency, useDependency]);
